import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ChevronDown } from 'lucide-react';
import { isCoach, isCoachRole, isEdgeCoach } from '@airreading/common';
import { AirAdminMenuItems } from '@/routes/_layout/users/-components/manage-air-admin';
import { ManageEdgeCoach } from '@/routes/_layout/users/-components/manage-edge-coach';
import { PromoteCoach } from '@/routes/_layout/users/-components/promote-coach';
import { ManageCoach } from '@/routes/_layout/users/-components/manage-coach';
import { SingleUserFull, UserRoleStatus } from '@airreading/common/data';

interface ManagePermissionsDropdownProps {
  user: SingleUserFull;
}

export function ManagePermissionsDropdown({ user }: ManagePermissionsDropdownProps) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" icon={ChevronDown}>
          Manage permissions
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {isCoach(user) ? (
          <ManageCoach
            trigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
                {user.userRoles.some((role) => isCoachRole(role) && role.status === UserRoleStatus.active)
                  ? 'Revoke teacher role'
                  : 'Restore teacher role'}
              </DropdownMenuItem>
            }
            user={user}
          />
        ) : (
          <PromoteCoach
            trigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Promote as teacher</DropdownMenuItem>}
            user={user}
          />
        )}

        <AirAdminMenuItems user={user} />

        <ManageEdgeCoach
          user={user}
          trigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              {isEdgeCoach(user) ? 'Remove Edge tutors' : 'Add Edge tutors'}
            </DropdownMenuItem>
          }
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
